import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";
import api from "../../../../../service/api";

export default function DuplicateModal({
    show,
    onClose,
    apiUrl,
    method = "POST",
    payload = {},
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    onSuccess = () => {},
    onError = () => {},
}) {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        if (loading) return;

        try {
            setLoading(true);

            const response = await api.post(apiUrl, payload);

            onSuccess(response.data);
            onClose();

        } catch (error) {

            const apiError = error?.response?.data;

            console.log('FULL ERROR:', error);
            console.log('API ERROR:', apiError);

            console.error(
                apiError?.error ||
                apiError?.message ||
                error.message ||
                "An error occurred during the request."
            );

            onError(apiError?.error || error?.message);

        } finally {
            setLoading(false);
        }
    };
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton={!loading}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="mb-0">{message}</p>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner size="sm" className="me-2" />
                            Processing...
                        </>
                    ) : (
                        "Confirm"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}